import React from 'react';
import { ReactComponent as AcmeLogo } from 'images/av-logo-vertical.svg';

export const Logo = (props) => <AcmeLogo width='118px' {...props} />;
